import BadgeComponent from 'components/BadgeComponent';
import React, { useMemo } from 'react';
import { capitalizeFirstLetter } from 'containers/helpers';
import StatusGesture from './StatusGesture';
import MyTable from 'components/MyTable/MyTable';
import { Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom'
import DateTooltip from 'components/DateTooltip';

const AppointmentBtocListComponent = ({
	appointments = []
}) => {
	const columns = useMemo(() => [
		{ title: 'Status', render: (props) => <StatusGesture {...props} /> },
		{ title: 'Titre de la mission', render: ({ title }) => title },
		{ title: 'Nombre de jours', render: ({ days }) => Object.keys(days).length },
		{ title: 'Freelance', render: ({ freelance }) => freelance },
		{ title: 'Client', render: ({ customer }) => customer },
		{ title: 'Jours', render: ({ days }) => <DateTooltip dates={days} />},
		{
			title: 'Voir les avis Review', render: ({ id }) => <Button as={Link}
				to={`/appointment/b2c/${id}`}>
				Accéder à la page du rdv
			</Button>
		},
	], [])

	const datas = useMemo(() => appointments
		.map((appointment) => ({
			...appointment,
            ...({ customer: `${capitalizeFirstLetter(appointment.customer_firstname)} ${capitalizeFirstLetter(appointment.customer_lastname)} [${appointment.customer}]` }),
			...({ freelance: `${capitalizeFirstLetter(appointment.freelance_firstname)} ${capitalizeFirstLetter(appointment.freelance_lastname)} [${appointment.freelance}]` }),
        })), [appointments])
	return (
		<MyTable
			columns={columns}
			data={datas}
			title={'Contrats'}
			sear
		/>
	);
};

export default AppointmentBtocListComponent;